const VERDICTS = {
  true: { label: "True", cls: "bg-[#16A34A] text-white" },
  mostly_true: { label: "Mostly True", cls: "bg-[#16A34A] text-white" },
  mixed: { label: "Mixed", cls: "bg-[#EAB308] text-black" },
  misleading: { label: "Misleading", cls: "bg-[#EAB308] text-black" },
  unproven: { label: "Unproven", cls: "bg-[#6B7280] text-white" },
  false: { label: "False", cls: "bg-[#DC2626] text-white" },
};

export default function VerdictBadge({ verdict, size = "sm" }) {
  if (!verdict) return null;
  const v = VERDICTS[verdict] || { label: verdict, cls: "bg-[#6B7280] text-white" };
  const pad = size === "lg" ? "px-4 py-2 text-sm" : "px-2.5 py-1 text-xs";
  return (
    <span
      data-testid={`verdict-badge-${verdict}`}
      className={`inline-flex items-center font-body font-bold uppercase tracking-wider ${pad} ${v.cls}`}
    >
      {v.label}
    </span>
  );
}
